export default __webpack_public_path__ + "img/fb492d43820079e4720bd2b32d8c4bce.png";